/**
 * Tenant Access Token — boundary contract schemas.
 *
 * Owned here, not beside the route: `apps/api/src/routes/manager/tenant-access-token.routes.ts`
 * (issue) and `apps/api/src/routes/tenant/access-token.routes.ts` (verify) import these to
 * register their routes, and `apps/landlord/src/lib/condition.api.ts` /
 * `apps/tenant/src/lib/condition.api.ts` derive their response/body types from the same
 * objects. See packages/api-types/README.md.
 *
 * DC-6 magic-link pair, no shape overlap between the two routes: a landlord issues a
 * lease-scoped, expiring token (BR-8a/8b) for accountless tenant participation in the
 * condition-walkthrough flow; the tenant app verifies the raw token once to resolve its
 * lease, then re-sends it as a bearer token on every subsequent
 * `condition-walkthrough`/`condition-items`/`condition-photos` call (see `condition/
 * walkthrough.ts`'s file header).
 *
 * Covers:
 *   POST /landlord/api/leases/:leaseId/tenant-access-token  (issue, manager)
 *   POST /tenant/api/access-token/verify                    (verify, tenant — PUBLIC)
 */
import { z } from 'zod';
// ============================================================================
// ISSUE — manager
// ============================================================================
export const IssueTokenBodySchema = z.object({
    purpose: z.string().min(1).max(50).optional(),
    ttlDays: z.number().int().min(1).max(365).optional(),
});
export const IssueTokenResponseSchema = z.object({
    tokenId: z.uuid(),
    leaseId: z.uuid(),
    purpose: z.string(),
    expiresAt: z.string(),
    /** Returned ONCE — never persisted or logged (BR-8b). */
    rawToken: z.string(),
    /** Ready-to-share tenant-app URL embedding the raw token. */
    magicLinkUrl: z.string(),
});
// ============================================================================
// VERIFY — tenant, PUBLIC (the raw token in the body is the authentication)
// ============================================================================
export const VerifyTokenBodySchema = z.object({
    token: z.string().min(1).max(512),
});
export const VerifyTokenResponseSchema = z.object({
    leaseId: z.uuid(),
    purpose: z.string(),
});
//# sourceMappingURL=access-token.js.map